<template>

    <form ref="colaborador-form-senha" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">
            <section class="col-md-6">
                <div class='form-group'>
                    <label>Nova Senha</label>
                    <input type='password' class='form-control' v-on:keyup="verificaSenha()" v-model='model.senhaMD5' name='senhaMD5' maxlength="10" />
                    <label>Nível da senha: </label>
                    <label v-if="nivelSenha == 1" style=" color: red !important;">Fraca</label>
                    <label v-if="nivelSenha == 2" style=" color: #FFA500 !important;">Mediana</label>
                    <label v-if="nivelSenha == 3" style=" color: green !important;">Forte</label>
                </div>
            </section>
            <section class="col-md-6">
                <div class='form-group'>
                    <label>Confirmacao de Senha</label>
                    <input type='password' class='form-control' v-model='model.senhaMD5Confirm' name='senhaMD5Confirm' maxlength="10" />
                    <label v-if="model.senhaMD5 != model.senhaMD5Confirm">As senhas diferem</label>
                </div>
            </section>
        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "colaborador-form-senha",
        mixins: [base],
        props: { colaboradorId: Number },
        data: () => ({
            nivelSenha: 0,
            model: {},
            form: "colaborador-form-senha",

            resources: {
                edit: 'colaborador',
            },

        }),

        methods: {

            executeEdit: function (model) {
                model.attributeBehavior = "AlterarSenha"
                model.colaboradorId = this.colaboradorId;
                new Api(this.resources.edit).put(model).then(data => {
                    this.defaultSuccessResult("Senha alterada com sucesso");
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            },

            verificaSenha: function () {
                this.nivelSenha = 0;

                var temLetra = /([a-z])/.test(this.model.senhaMD5);
                var temEspecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(this.model.senhaMD5);
                var temNumero = /\d/.test(this.model.senhaMD5);

                if (this.model.senhaMD5.length < 6) {
                    this.nivelSenha++;
                    return
                }

                if (temLetra) this.nivelSenha++;
                if (temEspecial) this.nivelSenha++;
                if (temNumero) this.nivelSenha++;
            }
        },
    };
</script>
